export const LOADING = "LOADING";
export const EVENT_TYPES = "EVENT_TYPES";
export const EVENT_BY_ID = "EVENT_BY_ID";
export const ALL_EVENTS = "ALL_EVENTS";
export const UPCOMING_EVENTS = "UPCOMING_EVENTS";
export const PAST_EVENTS = "PAST_EVENTS";
export const NOTIFICATION_SETTINGS = "NOTIFICATION_SETTINGS";
export const INTEGRATION_SUMMARY = "INTEGRATION_SUMMARY";
